export default "__VITE_ASSET__b3d38b3b__"